import {
  Project,
  ResourceAllocation,
  TimesheetEntry,
  AllocationInterval,
  AllocationType,
  AllocationSource,
  ProjectStatus,
  EntryType,
} from '../types'

function capitalize(value: string | undefined | null): string {
  if (!value) return value as string
  return value.charAt(0).toUpperCase() + value.slice(1)
}

function titleCase(value: string | undefined | null): string {
  if (!value) return value as string
  return value
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

function normalizeAllocationInterval(value: string | undefined | null): AllocationInterval {
  if (!value) return 'Daily'
  const lower = value.toLowerCase()
  if (lower === 'daily') return 'Daily'
  if (lower === 'weekly') return 'Weekly'
  if (lower === 'monthly') return 'Monthly'
  return capitalize(value) as AllocationInterval
}

function normalizeAllocationType(value: string | undefined | null): AllocationType {
  if (!value) return 'Actual'
  const lower = value.toLowerCase()
  if (lower === 'forecast') return 'Forecast'
  if (lower === 'actual') return 'Actual'
  if (lower === 'manual') return 'Actual'
  return capitalize(value) as AllocationType
}

function normalizeAllocationSource(value: string | undefined | null): AllocationSource {
  if (!value) return 'Manual'
  const lower = value.toLowerCase()
  if (lower === 'manual') return 'Manual'
  if (lower === 'imported') return 'Imported'
  if (lower === 'bulk_seed') return 'Imported'
  return capitalize(value) as AllocationSource
}

function normalizeProjectStatus(value: string | undefined | null): ProjectStatus {
  if (!value) return 'Active'
  const lower = value.toLowerCase()
  if (lower === 'active') return 'Active'
  if (lower === 'on hold') return 'On Hold'
  if (lower === 'closed') return 'Closed'
  if (lower === 'tentative') return 'Tentative'
  return titleCase(value) as ProjectStatus
}

function normalizeEntryType(value: string | undefined | null): EntryType {
  if (!value) return 'Manual'
  const lower = value.toLowerCase()
  if (lower === 'manual' || lower === 'standard') return 'Manual'
  if (lower === 'imported') return 'Imported'
  return capitalize(value) as EntryType
}

export function normalizeAllocations(allocations: ResourceAllocation[]): ResourceAllocation[] {
  return allocations.map((a) => ({
    ...a,
    allocation_interval: normalizeAllocationInterval(a.allocation_interval),
    allocation_type: normalizeAllocationType(a.allocation_type),
    allocation_source: normalizeAllocationSource(a.allocation_source),
  }))
}

export function normalizeProjects(projects: Project[]): Project[] {
  return projects.map((p) => ({
    ...p,
    status: normalizeProjectStatus(p.status),
  }))
}

export function normalizeTimesheetEntries(entries: TimesheetEntry[]): TimesheetEntry[] {
  return entries.map((e) => ({
    ...e,
    entry_type: normalizeEntryType(e.entry_type),
  }))
}
